import {Question} from "./Question";

export class QuestionPage {
    code: String;
    headerText: String;
    questions: Question[] = [];

    constructor() {
        this.code = '';
        this.headerText = '';
    }
}
